import { ArrowLeft, Check, Pencil, Plus, Tag, X } from "lucide-react";
import { useContext, useEffect, useRef, useState } from "react";
import { SidebarContext } from "../../contexts/sidebar.context";
import { useApi } from "../../hooks/api.hook";
import { ToasterContext } from "../../contexts/toaster.context";
import { AuthContext } from "../../contexts/auth.context";
import EditLabel from "./components/EditLabel";
import { ILabel } from "../../shared/type/list.type";

export default function Labels() {

    const sidebar = useContext(SidebarContext);
    const toaster = useContext(ToasterContext);
    const auth = useContext(AuthContext);
    const labelService = useApi<ILabel[]>("label");
    const inputRef = useRef<HTMLInputElement>(null);

    const [labels, setLabels] = useState<ILabel[]>([]);
    async function addLabel(label: string) {

        const res = await labelService.post(undefined, {
            label
        });

        if (!res.ok) {
            // toaster.makeToast(res.data?.message);
            return;
        }

        auth.setUser(res.data);
    }

    const [labelInput, setLabelInput] = useState("");

    useEffect(() => {
        if (!auth.user) return;

        setLabels(auth.user.labels)
    }, [auth.user])

    return (
        <div className="h-screen grid grid-rows-[auto_1fr] overflow-auto">
            <div>
                <div className="border-b border-[#ffffff33]">
                    <div className="mx-auto max-w-screen-md flex items-center gap-4 py-2">
                        <div>
                            <button onClick={() => sidebar.setSel(0)} className="btn btn-ghost"><ArrowLeft /></button>
                        </div>
                        <div className="flex-1">
                            Edit Labels
                        </div>
                    </div>
                </div>
                <div className="border-b border-[#ffffff33]">
                    <div className="mx-auto max-w-screen-md flex items-center gap-4 py-2">
                        <div>
                            <button onClick={() => {
                                if (labelInput) {
                                    setLabelInput("");
                                }
                                inputRef.current?.focus();
                            }} className="btn btn-ghost">{labelInput ? <X /> : <Plus />}</button>
                        </div>
                        <div className="flex-1">
                            <input ref={inputRef} value={labelInput} onChange={(e) => setLabelInput(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    addLabel(labelInput);
                                    setLabelInput("");
                                }
                            }}
                            placeholder="Create new label" className="outline-none border-none bg-transparent w-full" />
                        </div>
                        <div>
                            <button onClick={() => {
                                addLabel(labelInput);
                                setLabelInput("");
                            }} className="btn btn-ghost"><Check /></button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="overflow-auto">
                <div className="mx-auto max-w-screen-md">

                    {labels.map(v => (
                        <EditLabel key={`label-${v.id}`} label={v} />
                    ))}

                    {/* <div className="flex items-center gap-4 py-2">
                        <div>
                            <button className="btn btn-ghost"><Tag /></button>
                        </div>
                        <div className="flex-1">
                            <p>Label 1</p>
                        </div>
                        <div>
                            <button className="btn btn-ghost"><Pencil /></button>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 py-2">
                        <div>
                            <button className="btn btn-ghost"><Tag /></button>
                        </div>
                        <div className="flex-1">
                            <p>Label 2</p>
                        </div>
                        <div>
                            <button className="btn btn-ghost"><Pencil /></button>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}